import {Routes} from '@angular/router'
import {
  adminAuthGuard,
  LoginComponent
} from '@sparbanken-syd/sparbanken-syd-bankid'

import {ADMIN_HOME_PATH, LOGIN_PATH} from './application/app'


export const routes: Routes = [
  {
    path: ADMIN_HOME_PATH,
    loadChildren: () => import('./admin/admin.routes'),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
